import React from '../helpers/react';
import Step from '../components/Step.js';
import Loader from './Loader.js';
import NoSubSolution from '../components/NoSubSolution.js';
import {toggleSolution, postComment, toggleComments, removeComment} from '../actions/problem.action.js';
import {connect} from '../helpers/composeReducer.js';
import {pushPath} from 'redux-simple-router';
import classList from 'ereader-core/dist/classList.js';
import {getHookClass} from '../helpers/cssHooks.js';

export const Solution =  React.createClass({
    getHeader : function(){
        let title = this.props.getDef('solution.title', {}, {
            problem_exists: this.props.problem_exists
        });

        return (<header key='header'><h3 className="player-title">
            {title}
        </h3></header>)
    },

    getStep : function(step, index){
        let opened = this.props.opened_solutions;
        let opened_comments = this.props.opened_comments;
        return (
            <li key={step.id}>
                <Step
                    index={index}
                    show_comments={this.props.show_comments}
                    problemId={this.props.problemId}
                    comments={this.props.comments}
                    postComment={this.props.postComment}
                    removeComment={this.props.removeComment}
                    toggleComments={this.props.toggleComments}
                    total={this.props.total_steps}
                    toggle={this.props.toggleSolution}
                    opened={opened[step.id]}
                    opened_comment={opened_comments[step.id]}
                    solution_id={this.props.solution_id}
                    user={this.props.user}
                    getDef={this.props.getDef}
                    show_fullscreen={this.props.show_fullscreen}
                    {...step} />
            </li>
        );
    },

    render : function(){   
        let show_loader = (!this.props.total_steps && this.props.problem_exists) || !this.props.problemName;
        let content = [
            this.getHeader()
        ];

        if(this.props.pageTitle && this.props.enableTitleChange){
            document.title = this.props.pageTitle;
        }

        let solution = <ol className="steps" key='steps'>
            {this.props.steps.map(this.getStep)}
        </ol>;
        let has_extra_steps = this.props.total_steps > this.props.steps.length;
        let extra_steps = has_extra_steps ? <NoSubSolution /> : '';

        if (!show_loader) {
            content.push(solution);
            content.push(extra_steps);
        } else {
            content.push(Loader('loader-steps'));
        }

        let mainClass = classList('solution', getHookClass('Solution'));
        return (
            <section className={mainClass}>
                {content}
            </section>
        );
    }
});

export function mapStateToProps(state){
    let problem = state.problem;
    return {
        ...problem,
        user: state.options.user,
        show_comments: state.options.show_comments,
        getDef : state.helpers.getDef,
        show_fullscreen : state.options.show_fullscreen,
        enableTitleChange: state.model.enableTitleChange
    };

}

export default connect(mapStateToProps,{toggleSolution, toggleComments, postComment, removeComment, pushPath})(Solution);



// WEBPACK FOOTER //
// ./src/components/Solution.js